import React, { useState, useEffect, useRef, useMemo } from "react";
import KpiCard from "../components/KpiCard";
import zomatoLogo from "../assets/Zomato-Logo.png";
import SwiggyLogo from "../assets/Swiggy.png";
import ComparisonRow from "../components/ComparisonRow";
import ComparisonBarChart from "../components/ComparisonBarChart"
import { api } from "../utils/api";
import { getInsightText } from "../utils/getInsightText";
import DownloadReportButton  from "../components/DownloadReportButton"





// const RESTAURANTS = [
//     { value: "Mumbai_Ladu_Samrat", label: "Mumbai Ladu Samrat" },
//     { value: "Shobhaa_Only_Veg", label: "Shobhaa Only Veg" },
//     { value: "R_Bhagat_Tarrachand", label: "R Bhagat Tarrachand" },
//     { value: "MM_Mithaiwala", label: "MM Mithaiwala" },
//     { value: "Mm_Mithaiwala_Fast_Food", label: "Mm Mithaiwala Fast Food" },
//     { value: "Zaika_Fun_Dining", label: "Zaika Fun Dining" },
//     { value: "Annamaya", label: "Annamaya" },
//     { value: "Aegyo_-_Cafe_And_Bakehouse", label: "Aegyo - Cafe And Bakehouse" },
//     { value: "Bhagwati_Pav_Bhaji", label: "Bhagwati Pav Bhaji" }, 
//     { value: "Bhagwati_Veg_Restaurant", label: "Bhagwati Veg Restaurant" }
//   ];
export default function SwiggyVsZomato() {

  const [restaurant, setRestaurant] = useState("");
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  const [zomatoData, setZomatoData] = useState([])
  const [swiggyData, setSwiggyData] = useState([])
  const [isLoading, setIsLoading] = useState(true);
  const [currentMonthData, setCurrentMonthData] = useState(null);
  const [previousMonthData, setPreviousMonthData] = useState(null);
  const [currentNetSales, setCurrentNetSales] = useState(null);
  const [previousNetSales, setPreviousNetSales] = useState(null);
  const [resturantHeader, setRestaurantHeader] =  useState(null)
  const [headerMonth, setheaderMonth] = useState()
  const [swiggyCurrentMonthData, setswiggyCurrentMonthData] = useState(null);
  const [swiggyPreviousMonthData, setswiggyPreviousMonthData] = useState(null);
  const [swiggyCurrentNetSales, setswiggyCurrentNetSales] = useState(null);
  const [swiggyPreviousNetSales, setswiggyPreviousNetSales] = useState(null);
  const [periodList, setPeriodList] = useState([]);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [zomatoPlatform, setzomatoPlatform] = useState("");
  const [swiggyPlatform, setswiggyPlatform] = useState("");
  const [selectZomatoRestaurant, setSelectZomatoRestaurant] = useState("")
  const [selectSwiggyRestaurant, setSelectSwiggyRestaurant] = useState("")
  const [selectedMetric, setSelectedMetric] = useState("orders");
  const [restaurantNames, setrestaurantNames] = useState("")
  const [selectheaderDate, setHeaderDates] = useState("")





  const metricsExcel = useMemo(() => {
    if (!zomatoPlatform || !swiggyPlatform) return [];
  
    return [
      {
        metricType: "orders",
        label: "Orders",
        zomato: zomatoPlatform.orders,
        swiggy: swiggyPlatform.orders,
      },
      {
        metricType: "gmv",
        label: "GMV",
        zomato: zomatoPlatform.gmv,
        swiggy: swiggyPlatform.gmv,
      },
      {
        metricType: "discount",
        label: "Discount",
        zomato: zomatoPlatform.discount,
        swiggy: swiggyPlatform.discount,
      },
      {
        metricType: "menuOpen",
        label: "Menu Opens",
        zomato: zomatoPlatform.menuOpen,
        swiggy: swiggyPlatform.menuOpen,
      },
      {
        metricType: "cartbuild",
        label: "Cart Build",
        zomato: zomatoPlatform.cartbuild,
        swiggy: swiggyPlatform.cartbuild,
      },
      {
        metricType: "orderMake",
        label: "Order Make",
        zomato: zomatoPlatform.orderMake,
        swiggy: swiggyPlatform.orderMake,
      },
      {
        metricType: "adsMenuOpens",
        label: "Ads Menu Opens",
        zomato: zomatoPlatform.adsMenuOpens,
        swiggy: swiggyPlatform.adsMenuOpens,
      },
      {
        metricType: "adsOrders",
        label: "Ads Orders",
        zomato: zomatoPlatform.adsOrders,
        swiggy: swiggyPlatform.adsOrders,
      },
      {
        metricType: "adsSales",
        label: "Ads Sales",
        zomato: zomatoPlatform.adsSales,
        swiggy: swiggyPlatform.adsSales,
      },
      {
        metricType: "adsSpend",
        label: "Ads Spent",
        zomato: zomatoPlatform.billed_amount,
        swiggy: swiggyPlatform.billed_amount,
      },
      {
        metricType: "roi",
        label: "Ads ROI",
        zomato: zomatoPlatform.roi,
        swiggy: swiggyPlatform.roi,
      },
      {
        metricType: "burn",
        label: "Burn",
        zomato: zomatoPlatform.swiggyBurn,
        swiggy: swiggyPlatform.zomatoBurn,
      },
      {
        metricType: "adsDiscountBurn",
        label: "Ads + Discount Burn",
        zomato: zomatoPlatform.AdsDiscountburn,
        swiggy: swiggyPlatform.AdsDiscountburn,
      }
    ];
  }, [zomatoPlatform, swiggyPlatform]);


  const excelData = useMemo(() => {
    return metricsExcel.map((item) => {
      const percent =
        item.swiggy === 0
          ? 100
          : (((item.zomato - item.swiggy) / item.swiggy) * 100).toFixed(1);
  
      const leader = item.zomato > item.swiggy ? "Zomato" : "Swiggy";
  
      return {
        metric: item.label,
        zomato: item.zomato,
        swiggy: item.swiggy,
        insight: getInsightText(item.zomato, item.swiggy, item.metricType)
      };
    });
  }, [metricsExcel]);





  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true);
  
        // Dropdown API
        const dropdownData = await api("/restaurant-dropdown");
  
        setrestaurantNames(dropdownData)
  
        // Selected restaurant
        const firstRestaurant = dropdownData?.[4]?.value;

  
        if (!firstRestaurant) {
          console.error("Restaurant not found");
          return;
        }
  
        // Details API
        const detailsData = await api(
          `/zomato/restaurant/${firstRestaurant}`
        );
  
  
        const summary = detailsData?.summary || [];

       
  
      // No summary data
      if (summary.length === 0) {
        console.warn("No summary data found");
  
        setCurrentMonthData(null);
        setPreviousMonthData(null);
  
        return;
      }

  
        // Store full API response
        setZomatoData(summary);
  
        // Period list
        const allPeriods = dateConvert(summary);
        setPeriodList(allPeriods);
        setHeaderDates(allPeriods)
  
        // Latest months
        const currentMonth = summary[summary.length - 1];
        const prevMonth =
        summary.length > 1
          ? summary[summary.length - 2]
          : null;

       
  
        // Net sales
        const currNetSale =
          (currentMonth?.gmv || 0) -
          (currentMonth?.discount || 0);
  
        const prevNetSale =
          (prevMonth?.gmv || 0) -
          (prevMonth?.discount || 0);

          setSelectZomatoRestaurant(summary)

  
        // Header
        setRestaurantHeader(
          detailsData?.restaurant_name || ""
        );

        
        
        setzomatoPlatform(currentMonth)

  
        // Net sales
        setCurrentNetSales(currNetSale);
        setPreviousNetSales(prevNetSale);
  
        // Month data
        setCurrentMonthData(currentMonth);
        setPreviousMonthData(prevMonth);
  
  
        // Periods
        setSelectedPeriod(currentMonth?.period || "");
        setheaderMonth(currentMonth?.period || "");
  
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setIsLoading(false);
      }
    }
  
    loadData();
  }, []);


  const dateConvert = (resData) =>{

    return resData.map(item => ({
      raw: item.period,
      formatted: formatPeriod(item.period)
    }))

  }




  const dropdownRef = useRef(null);

  // useEffect(() => {
  //   api('/zomatoData')
  //   .then(data => {
  //     setTimeout(() => {
  //       setZomatoData(data);
  //       setIsLoading(false);
  //     }, 1000);
  //     const resData = data.zaika_fun_dining
  //     const allperiods = resData.map(item => ({
  //       raw: item.period,
  //       formatted: formatPeriod(item.period)
  //     }))
  //     setPeriodList(allperiods)
  //     const currentMonth = resData[resData.length - 1]
  //     const prevMonth = resData[resData.length -2]
  //     const currNetSale = currentMonth.gmv - currentMonth.discount
  //     const prevNetSale = prevMonth.gmv - prevMonth.discount
  //     setSelectZomatoRestaurant(resData)
  //     console.log("zomaot",currentMonth.res_name)
  //     setRestaurantHeader(currentMonth.res_name)
  //     setCurrentNetSales(currNetSale)
  //     setPreviousNetSales(prevNetSale)
  //     setCurrentMonthData(currentMonth)
  //     setPreviousMonthData(prevMonth)
  //     setheaderMonth(currentMonth.period)
  //     setSelectedPeriod(currentMonth.period)
  //     setzomatoPlatform(currentMonth)


  //   })
  //     .catch(console.error);
  // }

  // , []);



  useEffect(() => {
    async function loadData() {
      try {
        setIsLoading(true);
  
        // Dropdown API
        const dropdownData = await api("/restaurant-dropdown");
  
        setrestaurantNames(dropdownData)
  
        // Selected restaurant
        const firstRestaurant = dropdownData?.[4]?.value;
  
        if (!firstRestaurant) {
          console.error("Restaurant not found");
          return;
        }
  
        // Details API
        const detailsData = await api(
          `/swiggyrestaurant/${firstRestaurant}`
        );
  
  
        const summary = detailsData?.summary || [];


       
      //  setRestId(selectRestId);
  
      // No summary data
      if (summary.length === 0) {
        console.warn("No summary data found");
  
        setCurrentMonthData(null);
        setPreviousMonthData(null);
  
        return;
      }

  
        // Store full API response
        setSwiggyData(detailsData);
  
        // Period list
        const allPeriods = dateConvert(summary);
        setPeriodList(allPeriods);
        setHeaderDates(allPeriods)
  
        // Latest months
        const currentMonth = summary[summary.length - 1];
        const prevMonth =
        summary.length > 1
          ? summary[summary.length - 2]
          : null;

       

  
        // Net sales
        const currNetSale =
          (currentMonth?.gmv || 0) -
          (currentMonth?.discount || 0);
  
        const prevNetSale =
          (prevMonth?.gmv || 0) -
          (prevMonth?.discount || 0);


  
        // Header
        setRestaurantHeader(
          detailsData?.restaurant_name || ""
        );

        setSelectSwiggyRestaurant(summary)
    
      setheaderMonth(currentMonth.period)
      setswiggyPlatform(currentMonth)
  
        // Net sales
        setswiggyCurrentNetSales(currNetSale);
        setswiggyPreviousNetSales(prevNetSale);
  
        // Month data
        setswiggyCurrentMonthData(currentMonth);
        setswiggyPreviousMonthData(prevMonth);    
  
        // Periods
        setSelectedPeriod(currentMonth?.period || "");
        setheaderMonth(currentMonth?.period || "");
  
      } catch (error) {
        console.error("API Error:", error);
      } finally {
        setIsLoading(false);
      }
    }
  
    loadData();
  }, []);



  // useEffect(() => {
  //   api('/swiggyData')
  //   .then(data => {
  //     setTimeout(() => {
  //       setSwiggyData(data);
  //       setIsLoading(false);
  //     }, 1000);
  //     const resData = data.zaika_fun_dining
  //     const currentMonth = resData[resData.length - 1]
  //     const prevMonth = resData[resData.length -2]
  //     const currNetSale = currentMonth.gmv - currentMonth.discount
  //     const prevNetSale = prevMonth.gmv - prevMonth.discount
  //     setSelectSwiggyRestaurant(resData)
  //     console.log("swiggy",currentMonth.rest_name)
  //     setRestaurantHeader(currentMonth.rest_name)
  //     setswiggyCurrentNetSales(currNetSale)
  //     setswiggyPreviousNetSales(prevNetSale)
  //     setswiggyCurrentMonthData(currentMonth)
  //     setswiggyPreviousMonthData(prevMonth)
  //     setheaderMonth(currentMonth.period)
  //     setswiggyPlatform(currentMonth)
  //   })
  //     .catch(console.error);
  // }

  // , []);


  const calculateLatest = (data)=>{
    const resData = data.zaika_fun_dining
    const currentMonth = resData[resData.length - 1]


  }


  const formatPeriod = (period) => {
    const [year, month] = period.split("-");
  
    const date = new Date(year, month - 1); // month -1 because JS months start from 0
  
    return date.toLocaleString("en-US", {
      month: "short",
      year: "numeric",
    });
  };
  



useEffect(() => {
  const handleClickOutside = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setOpen(false);
    }
  };

  const handleEsc = (e) => {
    if (e.key === "Escape") setOpen(false);
  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("keydown", handleEsc);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("keydown", handleEsc);
  };
}, []);


  // useEffect(() => {
  //   const selected = RESTAURANTS.find(r => r.value === restaurant);
  //   if (selected) setSearch(selected.label);
  // }, [])


  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
  
    const handleEsc = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
  
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);
  
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

  if (!zomatoData) {
    return <div className="loader"></div>;
  }



  const calcChange = (curr, prev) => {
    if (!prev || prev === 0) {
      return curr > 0 ? "100.0" : "0.0";
    }
  
    return (((curr - prev) / prev) * 100).toFixed(1);
  };



  const newResData = async (value, label)=>{

    try {
      setIsLoading(true);
  
      // UI updates
      setRestaurant(value);
      setSearch(label);
      setOpen(false);
  
      // API Call
      const zomatodetailsData = await api(
        `/zomato/restaurant/${value}`
      );

      const swiggydetailsData = await api(
        `/swiggyrestaurant/${value}`
      );
    
      const zomatoSummary = zomatodetailsData?.summary || [];
  
      if (zomatoSummary.length === 0) {
        console.warn("No summary data found");
  
        setCurrentMonthData(null);
        setPreviousMonthData(null);
  
        return;
      }  
      const zomatoCurrentMonth = zomatoSummary[zomatoSummary.length - 1];
      const zomatoPrevMonth = zomatoSummary[zomatoSummary.length - 2];

    //  setselectedRestData(zomatoSummary)

  
      // Net Sales
      const zomatoCurrNetSale =
        (zomatoCurrentMonth?.gmv || 0) -
        (zomatoCurrentMonth?.discount || 0);
  
      const zomatoPrevNetSale =
        (zomatoPrevMonth?.gmv || 0) -
        (zomatoPrevMonth?.discount || 0);
  
      // Store data
      setZomatoData(zomatoSummary);
      setzomatoPlatform(zomatoCurrentMonth)
  
      const allPeriods = dateConvert(zomatoSummary);
      setPeriodList(allPeriods);
  
      setRestaurantHeader(
        zomatodetailsData?.restaurant_name || ""
      );
      setSelectZomatoRestaurant(zomatoSummary)
  
      setCurrentNetSales(zomatoCurrNetSale);
      setPreviousNetSales(zomatoPrevNetSale);
  
      setCurrentMonthData(zomatoCurrentMonth);
      setPreviousMonthData(zomatoPrevMonth);
  
      setSelectedPeriod(zomatoCurrentMonth?.period || "");
      setheaderMonth(zomatoCurrentMonth?.period || "");




       
      const swiggySummary = swiggydetailsData?.summary || [];


       
      //  setRestId(selectRestId);
  
      // No summary data
      if (swiggySummary.length === 0) {
        console.warn("No summary data found");
  
        setCurrentMonthData(null);
        setPreviousMonthData(null);
  
        return;
      }

  
        // Store full API response
        setSwiggyData(swiggySummary);
  
        // Period list
        // const allPeriods = dateConvert(summary);
        // setPeriodList(allPeriods);
        // setHeaderDates(allPeriods)
  
        // Latest months
        const swiggyCurrentMonth = swiggySummary[swiggySummary.length - 1];
        const swiggyPrevMonth =
        swiggySummary.length > 1
          ? swiggySummary[swiggySummary.length - 2]
          : null;

        

  
        // Net sales
        const swiggyCurrNetSale =
          (swiggyCurrentMonth?.gmv || 0) -
          (swiggyCurrentMonth?.discount || 0);
  
        const swiggyPrevNetSale =
          (swiggyPrevMonth?.gmv || 0) -
          (swiggyPrevMonth?.discount || 0);


  
        // Header
        setRestaurantHeader(
          swiggydetailsData?.restaurant_name || ""
        );

        setSelectSwiggyRestaurant(swiggySummary)
    
        setheaderMonth(swiggyCurrentMonth.period)
        setswiggyPlatform(swiggyCurrentMonth)
  
        // Net sales
        setswiggyCurrentNetSales(swiggyCurrNetSale);
        setswiggyPreviousNetSales(swiggyPrevNetSale);
  
        // Month data
        setswiggyCurrentMonthData(swiggyCurrentMonth);
        setswiggyPreviousMonthData(swiggyPrevNetSale);    
  
        // Periods
        setSelectedPeriod(swiggyCurrentMonth?.period || "");
        setheaderMonth(swiggyCurrentMonth?.period || "");
  



  
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setIsLoading(false);
    }
























    // const restVal = selectedResName.toLowerCase()


    // const resData = zomatoData[restVal]
    // console.log("zomatoData",resData)
    // const currentMonth = resData[resData.length - 1]
    // const prevMonth = resData[resData.length -2]
    // console.log("resdat",currentMonth)
    // const currNetSale = currentMonth.gmv - currentMonth.discount
    // const prevNetSale = prevMonth.gmv - prevMonth.discount
    // console.log("currNetSale",currNetSale)
    // setCurrentNetSales(currNetSale)
    // setPreviousNetSales(prevNetSale)
    // setCurrentMonthData(currentMonth)
    // setPreviousMonthData(prevMonth)
    // setRestaurantHeader(selectedResLabel)
    // setheaderMonth(currentMonth.period)
    // setzomatoPlatform(currentMonth)
    // setSelectZomatoRestaurant(resData)



    // const swggyData = swiggyData[restVal]
    // const currentSwiggyMonth = swggyData[swggyData?.length - 1]
    // console.log("resdat",currentSwiggyMonth)
    // const prevSwiggyMonth = swggyData[swggyData.length -2]
    // const currSwiggyNetSale = currentSwiggyMonth.gmv - currentSwiggyMonth.discount
    // const prevSwiggyNetSale = prevSwiggyMonth.gmv - prevSwiggyMonth.discount
    // setRestaurantHeader(currentMonth.res_name)
    // console.log("currSwiggyNetSale",currSwiggyNetSale)
    // setswiggyCurrentNetSales(currSwiggyNetSale)
    // setswiggyPreviousNetSales(prevSwiggyNetSale)
    // setswiggyCurrentMonthData(currentSwiggyMonth)
    // setswiggyPreviousMonthData(prevSwiggyMonth)
    // setRestaurantHeader(selectedResLabel)
    // setswiggyPlatform(currentSwiggyMonth)
    // setSelectSwiggyRestaurant(swggyData)

  }



  const onSelectedDate = (selectedDate)=>{

    



   const swiggyFilterData = selectSwiggyRestaurant.find((values) => {
    return values.period === selectedDate;
  });

  const zomatoFilterData = selectZomatoRestaurant.find((values) => {
    return values.period === selectedDate;
  });

  console.log("swiggyFilterData",swiggyFilterData)
  console.log("zomatoFilterData",swiggyFilterData)



    setswiggyPlatform(swiggyFilterData)
    setzomatoPlatform(zomatoFilterData)





  }


  const metrics = [
    { key: "orders", label: "Orders", currency: false },
    { key: "gmv", label: "GMV", currency: true },
    { key: "aov", label: "AOV", currency: true },
    { key: "discount", label: "Discount", currency: true },
  ];

  const activeMetric = metrics.find(m => m.key === selectedMetric);


  console.log("palt", swiggyPlatform)



  console.log("excelData", excelData)




  return (

    <>
    
    {
        isLoading?   <span class="loader"></span>
        :
        <>
        <div className="min-h-screen bg-gray-100 p-6">
        <h1 className="text-2xl font-bold mb-6">Platform Comparison</h1>
        <div
  ref={dropdownRef}
  className="relative w-full transition-shadow focus-within:shadow-md mb-4"
>
  {/* Search Icon */}
  <div className="absolute inset-y-0 left-3 flex items-center pointer-events-none">
    <svg
      className="w-6 h-6 text-gray-400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      viewBox="0 0 24 24"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 21l-4.35-4.35m0 0A7.5 7.5 0 1010.5 18a7.5 7.5 0 006.15-3.35z"
      />
    </svg>
  </div>

  {/* INPUT */}
  <input
    type="text"
    value={search}
    onChange={(e) => {
      setSearch(e.target.value);
      setOpen(true);
    }}
    onFocus={() => setOpen(true)}
    placeholder="Search restaurant..."
    className="
      w-full
      pl-12
      pr-4
      py-3
      border
      rounded-lg
      text-base
      bg-white
      focus:outline-none
      focus:ring-2
      focus:ring-indigo-500
    "
  />

  {/* DROPDOWN */}
  {open && (
    <div
      className="
        absolute
        top-full
        left-0
        z-50
        mt-2
        w-full
        bg-white
        border
        rounded-lg
        shadow-lg
        max-h-72
        overflow-y-auto
      "
    >
      {restaurantNames
        .filter((r) =>
          r.label.toLowerCase().includes(search.toLowerCase())
        )
        .map((r) => (
          <div
            key={r.value}
            onClick={() => {
              newResData(r.value, r.label);
            }}
            className="
              px-4
              py-3
              cursor-pointer
              hover:bg-gray-100
              text-base
            "
          >
            {r.label}
          </div>
        ))}

      {restaurantNames.filter((r) =>
        r.label.toLowerCase().includes(search.toLowerCase())
      ).length === 0 && (
        <div className="px-4 py-3 text-gray-400 text-base">
          No results
        </div>
      )}
    </div>
  )}
</div>

   <div className="flex items-center justify-between gap-6 mb-2">
 <div className="mt-1 mb-2 text-lg font-semibold text-gray-700">
    Restaurant Name: {resturantHeader}
    
</div>
<div className="mt-1 mb-2 text-lg font-semibold text-gray-700" >
      Month: {formatPeriod(headerMonth)}

    </div>

</div>
   
<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">   
   {/* Example KPI */}
   <KpiCard
       title="Orders"
       value={currentMonthData?.orders}
       percentage={`${calcChange(currentMonthData?.orders, previousMonthData?.orders)}%`}
       isUp={currentMonthData?.orders >= previousMonthData?.orders}
       gradient="bg-gradient-to-r from-[#EF4F5F] to-red-600"
       dataKey="orders"
       logo={zomatoLogo}
   
     />
     <KpiCard
       title="Gross Sales"
       value={`₹${Math.round(currentMonthData?.gmv).toLocaleString()}`}
       percentage={`${calcChange(currentMonthData?.gmv, previousMonthData?.gmv)}%`}
       isUp={
        parseFloat(String(currentMonthData?.gmv).replace(/,/g, "")) >
        parseFloat(String(previousMonthData?.gmv).replace(/,/g, ""))
      }       
      gradient="bg-gradient-to-r from-red-500 to-red-600"
       dataKey="orders"
       logo={zomatoLogo}
   
     />
     <KpiCard
       title="Ad Spent"
       value={`₹${currentMonthData?.billed_amount.toLocaleString()}`}
       percentage={`${calcChange(currentMonthData?.billed_amount, previousMonthData?.billed_amount)}%`}
       isUp={currentMonthData?.billed_amount >= previousMonthData?.billed_amount}
       gradient="bg-gradient-to-r from-red-500 to-red-600"
       dataKey="orders"
       logo={zomatoLogo}
   
     />
     <KpiCard
       title="Net Sales"
       value={`₹${Math.round(currentNetSales).toLocaleString()}`}
       percentage={`${calcChange(currentNetSales, previousNetSales)}%`}
       isUp={currentNetSales > previousNetSales}
       gradient="bg-gradient-to-r from-red-500 to-red-600"
       dataKey="orders"
       logo={zomatoLogo}
   
     />
     <KpiCard
       title="Orders"
       value={swiggyCurrentMonthData?.orders}
       percentage={`${calcChange(swiggyCurrentMonthData?.orders, swiggyPreviousMonthData?.orders)}%`}
       isUp={swiggyCurrentMonthData?.orders > swiggyPreviousMonthData?.orders}
       gradient="bg-gradient-to-r from-orange-400 to-orange-600"
       dataKey="orders"
       logo={SwiggyLogo}
   
     />
     <KpiCard
       title="Gross Sales"
       value={`₹${Math.round(swiggyCurrentMonthData?.gmv).toLocaleString()}`}
       percentage={`${calcChange(swiggyCurrentMonthData?.gmv, swiggyPreviousMonthData?.gmv)}%`}
       isUp={
        parseFloat(String(swiggyCurrentMonthData?.gmv).replace(/,/g, "")) >
        parseFloat(String(swiggyPreviousMonthData?.gmv).replace(/,/g, ""))
      }       gradient="bg-gradient-to-r from-[#FC8019] to-orange-600"
       dataKey="gmv"
       logo={SwiggyLogo}
   
     />
     <KpiCard
       title="Ad Spent"
       value={`₹${swiggyCurrentMonthData?.billed_amount.toLocaleString()}`}
       percentage={`${calcChange(swiggyCurrentMonthData?.billed_amount, swiggyPreviousMonthData?.billed_amount)}%`}
       isUp={swiggyCurrentMonthData?.billed_amount >= swiggyPreviousMonthData?.billed_amount}
       gradient="bg-gradient-to-r from-[#FC8019] to-orange-600"
       dataKey="orders"
       logo={SwiggyLogo}
   
     />
     <KpiCard
       title="Net Sales"
       value={`₹${Math.round(swiggyCurrentNetSales).toLocaleString()}`}
       percentage={`${calcChange(swiggyCurrentNetSales, swiggyPreviousNetSales)}%`}
       isUp={swiggyCurrentNetSales > swiggyPreviousNetSales}
       gradient="bg-gradient-to-r from-[#FC8019] to-orange-600"
       dataKey="orders"
       logo={SwiggyLogo}
   
     />
   
   
     </div>
     <div className="bg-white rounded-xl shadow overflow-hidden mt-4">

{/* Top Section */}
<div className="px-6 py-5 border-b border-gray-100">
  <div className="flex items-center justify-between gap-6">
    <h2 className="text-lg font-semibold text-gray-800">
      Platform Performance Comparison
    </h2>

    <DownloadReportButton
  data={excelData}
  restaurantName={resturantHeader}
  date={formatPeriod(selectedPeriod)}

/>

    <select
      value={selectedPeriod}
      onChange={(e) => {
        onSelectedDate(e.target.value);
        setSelectedPeriod(e.target.value);
      }}
      className="border rounded-lg px-3 py-2"
    >
      {periodList.map((p) => (
        <option key={p.raw} value={p.raw}>
          {p.formatted}
        </option>
      ))}
    </select>
  </div>
</div>

{/* Sticky Column Headers */}
<div className="grid grid-cols-4 px-6 py-4 bg-gray-50 text-sm font-semibold text-gray-500 sticky top-0 z-10">
  <div>Metric</div>

  <div className="flex items-center gap-2">
    <img src={zomatoLogo} className="w-4 h-4" />
    Zomato
  </div>

  <div className="flex items-center gap-2">
    <img src={SwiggyLogo} className="w-4 h-4" />
    Swiggy
  </div>

  <div>Insight</div>
</div>

{/* Scrollable Body */}
<div className="max-h-[500px] overflow-y-auto px-6">

  <ComparisonRow
    label="Orders"
    zomato={zomatoPlatform?.orders}
    swiggy={swiggyPlatform?.orders}
    metricType="orders"
  />

  <ComparisonRow
    label="Gross Sales"
    zomato={zomatoPlatform?.gmv}
    swiggy={swiggyPlatform?.gmv}
    metricType="gmv"
    isCurrency
  />

  <ComparisonRow
    label="Discount"
    zomato={zomatoPlatform?.discount}
    swiggy={swiggyPlatform?.discount}
    metricType="discount"
    isCurrency
  />

  <ComparisonRow
    label="Menu Open"
    zomato={zomatoPlatform?.menuOpen}
    swiggy={swiggyPlatform?.menuOpen}
    metricType="menuOpen"
  />

  <ComparisonRow
    label="Cart Build"
    zomato={zomatoPlatform?.cartbuild}
    swiggy={swiggyPlatform?.cartbuild}
    metricType="cartbuild"
  />

  <ComparisonRow
    label="Order Make"
    zomato={zomatoPlatform?.orderMake}
    swiggy={swiggyPlatform?.orderMake}
    metricType="orderMake"
  />

  <ComparisonRow
    label="Ads Menu Opens"
    zomato={zomatoPlatform?.adsMenuOpens}
    swiggy={swiggyPlatform?.adsMenuOpens}
    metricType="adsMenuOpens"
  />

  <ComparisonRow
    label="Ads Orders"
    zomato={zomatoPlatform?.adsOrders}
    swiggy={swiggyPlatform?.adsOrders}
    metricType="adsOrders"
  />

  <ComparisonRow
    label="Ads Sales"
    zomato={zomatoPlatform?.adsSales}
    swiggy={swiggyPlatform?.adsSales}
    metricType="adsSales"
    isCurrency
  />

  <ComparisonRow
    label="Ads Spent"
    zomato={zomatoPlatform?.billed_amount}
    swiggy={swiggyPlatform?.billed_amount}
    metricType="adsSpend"
    isCurrency
  />

  <ComparisonRow
    label="Ads ROI"
    zomato={zomatoPlatform?.roi}
    swiggy={swiggyPlatform?.roi}
    metricType="roi"
  />

  <ComparisonRow
    label="Burn"
    zomato={zomatoPlatform?.zomatoBurn}
    swiggy={swiggyPlatform?.swiggyBurn}
    metricType="burn"
    isCurrency
  />

  <ComparisonRow
    label="Ads + Discount Burn"
    zomato={zomatoPlatform?.AdsDiscountburn}
    swiggy={swiggyPlatform?.AdsDiscountburn}
    metricType="adsDiscountBurn"
  />

</div>

</div>

    <div className="bg-white rounded-xl shadow p-6 mt-4">

{/* Metric Selector */}
<div className="flex gap-2 mb-6">
  {metrics.map(metric => (
    <button
      key={metric.key}
      onClick={() => setSelectedMetric(metric.key)}
      className={`px-4 py-2 rounded-md text-sm font-medium transition
        ${
          selectedMetric === metric.key
            ? "bg-indigo-600 text-white"
            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
        }`}
    >
      {metric.label}
    </button>
  ))}
</div>




{/* Chart */}
<ComparisonBarChart
  title={`${activeMetric.label} Comparison`}
  metricKey={activeMetric.key}
  isCurrency={activeMetric.currency}
  zomatoData={selectZomatoRestaurant}
  swiggyData={selectSwiggyRestaurant}
/>
</div>
   
   
   
   </div>
   
        
        
        </>

    }
    
    </>
  )
}
